<template>
  <div>
    <app-cells position="between">
      <h1 class="title">Cashflow Reconciliation</h1>
      <app-button @click.native="onShowExportModal" v-if="is_general_manager">Export</app-button>
    </app-cells>
    <app-tabs :tabs="tabs_to_show" />
    <transition name="fade" mode="out-in">
      <router-view />
    </transition>
    <modal
      name="exportModal"
      :width="400"
      :height="'auto'"
      :scrollable="true"
      :adaptive="true"
      :clickToClose="false"
      draggable=".popup__title"
      class="modal-not-overflow"
    >
      <div class="popup">
        <button @click="$modal.hide('exportModal')" class="popup__close" type="button"></button>
        <div class="popup__title">Export</div>
        <div class="popup__body">
          <form @submit.prevent="onCheckFormExport">
            <app-form-group label="Date Range" required>
              <app-date-picker
                v-model="form_export.period"
                range
                :clearable="false"
                placeholder="Date Range"
                :error="$v.form_export.period.$error"
              />
              <template #error>
                <div v-if="$v.form_export.period.$dirty && !$v.form_export.period.required">Required field</div>
              </template>
            </app-form-group>
            <app-form-group label="Accounts" required>
              <app-select
                v-model="form_export.accounts"
                :reduce="item => item.id"
                :options="account_options"
                multiple
                placeholder="Accounts"
                :error="$v.form_export.accounts.$error"
              />
              <template #error>
                <div v-if="$v.form_export.accounts.$dirty && !$v.form_export.accounts.required">Required field</div>
              </template>
            </app-form-group>
            <app-cells position="center" :indent="false">
              <app-button type="submit" ref="submitExport" :disabled="$v.form_export.$error">Export</app-button>
            </app-cells>
          </form>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import AppTabs from '@/components/AppTabs'
import { getFinanceAccounts, getFinanceCashflowReconciliationExport } from '@/http'
import { format, parse } from 'date-fns'
import { required } from 'vuelidate/lib/validators'

export default {
  name: 'FinanceCashflowReconciliationLayout',
  components: { AppTabs },
  data() {
    return {
      tabs: [
        { name: 'finance-cashflow-reconciliation-nmb', label: 'NMB', roles: ['general_manager', 'accountant_supervisor']},
        { name: 'finance-cashflow-reconciliation-equity', label: 'Equity', roles: ['general_manager', 'accountant_supervisor']},
        { name: 'finance-cashflow-reconciliation-wise', label: 'Wise', roles: ['general_manager']},
        { name: 'finance-cashflow-reconciliation-kassa', label: 'Kassa', roles: ['general_manager']},
        { name: 'finance-cashflow-reconciliation-stripe', label: 'Stripe', roles: ['general_manager']},
        { name: 'finance-cashflow-reconciliation-rule', label: 'Rule engine', roles: ['general_manager']},
      ],
      tabs_to_show: [],
      form_export: {},
      account_options: [],
    }
  },
  validations: {
    form_export: {
      accounts: { required },
      period: { required },

    }
  },
  computed: {
    is_general_manager() {
      return this.$store.state.userGroups.map(item => item.code).includes('general_manager')
    },
  },
  created() {
    getFinanceAccounts().then(response => { this.account_options = response.data })
    const tabs = []
    this.tabs.forEach(item => {
      if (!item.roles.length) {
        tabs.push(item)
        return
      }
      item.roles.forEach(role => {
        if (this.$store.state.userGroups.some(groupRole => groupRole.code === role)) tabs.push(item)
      })
    })
    this.tabs_to_show = tabs
  },
  methods: {
    onShowExportModal() {
      this.form_export = {}
      this.$v.form_export.$reset()
      this.$modal.show('exportModal')
    },
    onCheckFormExport() {
      this.$v.form_export.$touch()
      if (this.$v.form_export.$invalid) {
        this.$notify({
          type: 'info',
          title: 'Check that the form fields are filled in correctly',
        })
      } else {
        this.sendFormExport()
      }
    },
    sendFormExport() {
      this.$refs.submitExport.preload = true
      getFinanceCashflowReconciliationExport(
        {
          accounts: this.form_export.accounts,
          date_after: this.form_export.period[0],
          date_before: this.form_export.period[1],
        }
      )
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', `Cashflow Reconciliation export ${this.dateFormat(this.form_export.period[0])}-${this.dateFormat(this.form_export.period[1])}.xlsx`)
          document.body.appendChild(link)
          link.click()
          URL.revokeObjectURL(url)
          this.$modal.hide('exportModal')
        })
        .catch(() => { this.$refs.submitExport.preload = false })
    },
    dateFormat(date) {
      return format(parse(date, 'yyyy-MM-dd', new Date()), 'dd MMM yyyy')
    },
  }
}
</script>
